import React from "react"
import styled from "styled-components"
import { breakpoint } from "../utils/breakpoint"

const StyledDiv = styled.div`
  flex: 0 0 auto;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background-color: #0f6497;

  ${breakpoint.sm} {
    width: 12px;
    height: 12px;
  }
  ${breakpoint.lg} {
    width: 9px;
    height: 9px;
  }
`

const DarkBlueCircle = props => {
  return (
    <StyledDiv
      style={{
        ...props.style,
      }}
    />
  )
}

export default DarkBlueCircle
